import React from "react";
import { DialogRoot } from "components/ui/dialog";
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@chakra-ui/react";
import { Button } from "components/ui/button";
import imagePlaceholder from "assets/img/dashboards/img-placeholder.jpg";
import { localizeFacilitySize } from "utils/localization";
const BASE_URL = process.env.REACT_APP_ENDPOINT;

const ContractInfo = ({ contractor }) => {
  return (
    <DialogRoot scrollBehavior="inside" dir="rtl">
      <DialogTrigger asChild>
        <button
          variant="outline"
          className=" rounded-full bg-blueSecondary px-6 py-1 text-white transition-all hover:bg-brandLinear disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
          size="sm"
        >
          بيانات العقد
        </button>
      </DialogTrigger>
      <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">بيانات العقد</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="flex flex-col gap-4">
            {/* image */}
            <div>
              <a
                href={`${BASE_URL}/${contractor?.commercialRegisterPhoto}`}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={
                    `${BASE_URL}/${contractor?.commercialRegisterPhoto}` ||
                    imagePlaceholder
                  }
                  alt="صورة السجل التجاري"
                  className="w-[200px] border border-gray-200"
                  crossOrigin="anonymous"
                />
              </a>
            </div>

            <div className="flex items-center gap-4">
              <span className="font-bold">حجم المنشأة:</span>
              <span>{localizeFacilitySize(contractor?.facilitySize)}</span>
            </div>
            <div className="flex items-center gap-4">
              <span className="font-bold">الوصف:</span>
              <span>{contractor?.description}</span>
            </div>

            <div className="flex items-center gap-4">
              <span className="font-bold">البريد الإلكتروني:</span>
              <span>{contractor?.email}</span>
            </div>
            <div className="flex items-center gap-4">
              <span className="font-bold">اسم المؤسسة:</span>
              <span>{contractor?.institutionName}</span>
            </div>
            {contractor?.commercialRegister && (
              <div className="flex items-center gap-4">
                <span className="font-bold">السجل التجاري:</span>
                <span>{contractor?.commercialRegister}</span>
              </div>
            )}
            {contractor?.commercialRegisterExpirationDate && (
              <div className="flex items-center gap-4">
                <span className="font-bold">تاريخ انتهاء السجل:</span>
                <span>
                  {new Date(
                    contractor.commercialRegisterExpirationDate
                  ).toLocaleDateString("ar-EG")}
                </span>
              </div>
            )}
            {contractor?.membershipNumber && (
              <div className="flex items-center gap-4">
                <span className="font-bold">رقم العضوية:</span>
                <span>{contractor?.membershipNumber}</span>
              </div>
            )}
          </div>
        </DialogBody>
        <DialogFooter>
          <DialogActionTrigger asChild>
            <Button variant="outline">
              <span>إلغاء</span>
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default ContractInfo;
